// assets/inspector-directory.js
window.EPC_INSPECTORS = {
  // Example entries — edit to match your real pages/teams
  "malcrawford": {
    name:  "Mal Crawford",
    phone: "0447 359 222",
    email: "admin@easypoolcert.com.au",
    region:"Gold Coast"
  },
  "gunter-keil": {
    name:  "Gunter Keil",
    phone: "0423 779 423",
    email: "gunter@easypoolcert.com.au",
    region:"Sunshine Coast"
  }
};
